<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="cop">
<p class="nonindent"><span class="small">THOMAS DUNNE BOOKS.</span><br/>An imprint of St. Martin’s Press.</p>
<p class="nonindent"><span class="small">FIRST BLUE</span>. Copyright © 2004 by Robert K. Wilcox. Foreword copyright © 2004 by James Lovell. All rights reserved. Printed in the United States of America. No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of brief quotations embodied in critical articles or reviews. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="nonindent"><em>Map by James Sinclair</em></p>
<p class="nonindent"><a class="pubhlink" href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="nonindent">Library of Congress Cataloging-in-Publication Data</p>
<p class="nonindent">Wilcox, Robert K.<br/>   First blue : the story of World War II Ace Butch Voris and the creation of the Blue Angels / Robert K. Wilcox.<br/>      p. cm.<br/>   ISBN 0-312-32249-6<br/>   EAN 978-0312-32249-6<br/>   1. Voris, Roy Marlin, 1920– 2. Fighter pilots—United States—Biography. 3. World War, 1939–1945—Campaigns—Pacific Ocean. 4. United States. Naval Flight Demonstration Squadron—History. 5. United States. Navy—Officers—Biography. I. Title.</p>
<p class="nonindent">V63.V73W54 2004<br/>359.9′4′092—dc22<br/>[B]</p>
<p class="nonindent">                                                                              2004046752</p>
<p class="nonindent">First Edition: October 2004</p>
<p class="nonindent">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312322496_epub_cop_r1.vue?52b7e459